import {
    FETCH_IMPORT_REVIEWS_SUCCESS,
    FETCH_IMPORT_REVIEWS_FAILURE,
    UPDATE_IMPORT_REVIEWS_REQUEST,
    RESET_IMPORT_REVIEW_STATE,
    FETCH_IMPORT_REVIEWS_FORM_REQUEST,
    FETCH_IMPORT_REVIEWS_FORM_SUCCESS,
    FETCH_IMPORT_REVIEWS_FORM_FAILURE
} from "../actions/importReviewsActions";

const initialState = {
    loading: false,
    reviewsResponse: [],
    error: "",
};

const importReviewsReducer = (state = initialState, action) => {
    switch (action.type) {
    case FETCH_IMPORT_REVIEWS_FORM_REQUEST:
        return { ...state, loading: true };
    case FETCH_IMPORT_REVIEWS_FORM_SUCCESS:
        return {
            ...state,
            loading: false,
            reviewsResponse: action.payload,
            error: "",
        };
    case FETCH_IMPORT_REVIEWS_FORM_FAILURE:
        return {
            ...state,
            loading: false,
            reviewsResponse: [],
            error: action.payload,
        };
    case FETCH_IMPORT_REVIEWS_SUCCESS:
        console.log("success");
        return {
            ...state,
            loading: false,
            updating: false,
            reviewsResponse: action.payload,
            error: "",
        };
    case FETCH_IMPORT_REVIEWS_FAILURE:
        return {
            ...state,
            loading: false,
            reviewsResponse: [],
            error: action.payload,
        };
    case UPDATE_IMPORT_REVIEWS_REQUEST:
        return {
            ...state,
            ...action.payload,
            loading: false,
            updating: true,
        };
    case RESET_IMPORT_REVIEW_STATE:
        return initialState;
    default:
        return state;
    }
};

export default importReviewsReducer;
